<template>
    <div class="tours">
        <div class="top">
            <div class="title">{{ title }}</div>
        </div>
        <div class="nav" v-if="navList.length > 0">
            <div class="nav-con">
                <div class="list" @click="changeNavFn(item, index)" :class="currentNav == index ? 'active' : ''"
                    v-for="(item, index) in navList" :key="index">
                    {{ item.nav_title_en || '' }}
                </div>
            </div>
        </div>
        <div class="content" v-else-if="nav_item.content">
            <div class="right">
                <div class="right-con">
                    <div class="right-con-title">{{ nav_item.nav_title_en || '' }}</div>
                    <div class="right-con-text" v-html="nav_item.content_en">
                    </div>
                </div>
            </div>
        </div>

        <div class="content" v-if="navList[currentNav] && navList[currentNav].children3">
            <div class="left">
                <div class="left-con">
                    <div class="list" @click="currentItemNav = index" :class="currentItemNav == index ? 'active' : ''"
                        v-for="(item, index) in navList[currentNav].children3" :key="index">
                        {{ item.nav_title_en || '' }}
                    </div>
                </div>
            </div>
            <div class="right" v-if="navList[currentNav].children3[currentItemNav]">
                <div class="right-con">
                    <div class="right-con-title">{{ navList[currentNav].children3[currentItemNav].nav_title_en || '' }}
                    </div>
                    <div class="right-con-text" v-html="navList[currentNav].children3[currentItemNav].content_en">
                    </div>
                </div>
            </div>
        </div>
        <div class="content" v-else-if="navList[currentNav] && navList[currentNav].content_en">
            <div class="right">
                <div class="right-con">
                    <div class="right-con-title">{{ navList[currentNav].nav_title_en || '' }}</div>
                    <div class="right-con-text" v-html="navList[currentNav].content_en">
                    </div>
                </div>
            </div>
        </div>
        <template
            v-if="navList[currentNav] && navList[currentNav].children3 && navList[currentNav].children3.length == 0">
            <div class="no-data">
                <img src="../../assets/imgs/no-data.png" alt="">
                <p>no data</p>
            </div>
        </template>
        <!-- <div class="good">
            <div class="carousel-title"><span>下签喜报</span></div>
            <div class="content">
                <el-carousel class="carousel" :interval="4000" :type="swiperType" height="550px">
                    <el-carousel-item v-for="(item, index) in list" :key="index">
                        <div class="img">
                            <img :src="item.img" alt="">
                        </div>
                        <div class="name u-line-1">{{ item.name }}</div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div> -->
    </div>
</template>

<script>

export default {
    data() {
        return {
            list: [],
            currentNav: 0,
            currentItemNav: 0,
            navList: [],

            title: '',
            nav_item: {},
            screenWidth: window.innerWidth,
            swiperType: ''
        }
    },
    watch: {
        '$route.query.nav_id': {
            handler(newVal) {
                this.$http.nav_list({
                    nav_id: newVal
                }).then(res => {
                    let nav_list = res.data || []
                    let nav_item = nav_list.find(item => item.nav_id == newVal) || JSON.parse(localStorage.getItem('nav_item')) || {}
                    this.title = nav_item.nav_title_en || '';
                    this.nav_item = nav_item;
                    this.navList = nav_item.children2 || [];
                    if (this.$route.query.currentNav) {
                        this.currentNav = this.$route.query.currentNav
                    } else {
                        this.currentNav = 0
                    }
                })
            },
            immediate: true
        },
        '$route.query.currentNav': {
            handler(newVal) {
                this.$http.nav_list({
                    nav_id: this.nav_item.nav_id
                }).then(res => {
                    let nav_list = res.data || []
                    let nav_item = nav_list.find(item => item.nav_id == this.nav_item.nav_id) || JSON.parse(localStorage.getItem('nav_item')) || {}
                    this.title = nav_item.nav_title_en || '';
                    this.nav_item = nav_item;
                    this.navList = nav_item.children2 || [];
                    if (newVal) {
                        this.currentNav = newVal
                    } else {
                        this.currentNav = 0
                    }
                })
            },
            immediate: true
        },
        '$route.query.currentItemNav': {
            handler(newVal) {
                if (newVal) {
                    this.currentItemNav = newVal
                } else {
                    this.currentItemNav = 0
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.handleScreenResize()
        window.addEventListener('resize', this.handleScreenResize)
        this.getNewGoodFn();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleScreenResize)
    },
    methods: {
        changeNavFn(item, index) {
            if (item.model_id == 1 &&item.url_en) {
                window.open(item.url_en)
                return
            }
            this.currentNav = index; this.currentItemNav = 0
        },
        handleScreenResize() {
            this.screenWidth = window.innerWidth
            if (this.screenWidth <= 600) {
                this.swiperType = ''
            } else {
                this.swiperType = 'card'
            }
        },
        getNewGoodFn() {
            //获取下签喜报
            this.$http.nav_list_view({ model_type_id: 854 }).then(res => {
                console.log(res)
            })
        }
    }
}
</script>

<style lang="less" scoped>
.tours {
    padding-bottom: 120px;
    background-color: #f1f1f1;

    .no-data {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin: 150px 0;
        color: #222222;

        img {
            width: 150px;
        }
    }

    .good {
        background-color: #fff;
        padding: 80px 0 40px;

        .carousel-title {
            text-align: center;
            position: relative;
            margin: 0 auto 80px;

            span {
                background-color: #fff;
                z-index: 2;
                padding: 0 20px;
                position: relative;
                color: #ae0000;
                font-size: 28px;
                text-transform: uppercase;
            }

            &::before {
                content: "";
                width: 500px;
                position: absolute;
                left: 50%;
                bottom: 10px;
                transform: translateX(-50%);
                border-bottom: 2px solid #910303;
            }

            &::after {
                content: "";
                width: 350px;
                position: absolute;
                left: 50%;
                top: 14px;
                transform: translateX(-50%);
                border-bottom: 2px solid #d31d1d;
            }

        }

        .carousel {
            width: 100%;

            .img {
                height: calc(100% - 50px);
                width: 100%;
                text-align: center;
            }

            img {
                width: auto;
                height: 100%;
            }

            .name {
                font-size: 18px;
                text-align: center;
                width: 70%;
                line-height: 50px;
                margin: 0 auto;
            }
        }
    }

    .content {
        max-width: 1200px;
        margin: 50px auto;
        display: flex;

        .left {
            width: 300px;
            flex-shrink: 0;

            .list {
                background-color: #fff;
                font-size: 16px;
                color: #222222;
                min-height: 45px;
                padding: 10px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                text-indent: 15px;
                border-bottom: 1px solid #9a730674;
                cursor: pointer;
                transition: .3s all;
            }

            .list:nth-last-child(1) {
                border-bottom: none;
            }

            .list:hover,
            .list.active {
                color: #666666;
                background-color: #40403f1c;
            }
        }

        .right {
            flex: 1;
            margin-left: 20px;

            .right-con {
                background-color: #fff;
                padding: 20px;

                .right-con-title {
                    font-size: 20px;
                    color: #222222;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #9a730674;
                }

                .right-con-text {
                    font-size: 16px;
                    min-height: 400px;
                }
            }

            .right-con-text {
                padding: 20px 10px;
                box-sizing: border-box;
            }
        }
    }

    .nav {
        width: 100%;
        padding: 20px 0;
        background-color: #fff;

        .nav-con {
            max-width: 1200px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
            flex-wrap: wrap;

            .list {
                font-size: 16px;
                height: 40px;
                padding: 0 10px;
                margin: 5px 10px;
                display: flex;
                align-items: center;
                cursor: pointer;
                justify-content: center;
                transition: .3s all;
                color: #666;
            }

            .list:nth-last-child(1) {}

            // .list.active {
            //     position: relative;
            //     color: #222222;
            //     transform: scale(1.1);
            //     border-radius: 6px;

            //     &::after {
            //         content: '';
            //         left: 50%;
            //         transform: translateX(-50%) scaleY(0.8);
            //         position: absolute;
            //         width: 80px;
            //         height: 2px;
            //         bottom: 10px;
            //         background-color: #222222;
            //     }
            // }

            .list:hover,
            .list.active {
                color: #666666;
                background-color: #40403f1c;
            }

        }
    }

    .top {
        width: 100vw;
        height: 300px;
        position: relative;
        overflow: hidden;
        background-image: url('../../assets/imgs/migration.jpg');
        background-size: auto 100%;
        transition: .3s all;
        background-position: center;

        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 60px;
            font-weight: 600;
            letter-spacing: 2px;
            color: #fff;
            text-shadow: 3px 3px 5px #222222;
        }



        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
            transition: .3s all;
        }

        &:hover {
            background-size: auto 110%;

            img {
                transform: scale(1.1);
            }
        }
    }


}

@media (max-width: 899px) {
    .tours {
        padding-bottom: 80px;

        .top {
            height: 200px;

            .title {
                font-size: 30px;
                width: 100%;
                text-align: center;
                padding: 0 20px;
                box-sizing: border-box;
            }
        }

        .nav {
            padding: 15px 0;

            .nav-con {
                padding: 0 10px;
                box-sizing: border-box;

                .list {
                    font-size: 14px;
                    height: 35px;
                    margin: 5px 5px;
                    padding: 0 8px;
                }
            }
        }

        .content {
            display: block;
            margin: 20px auto;
            width: calc(100% - 20px);

            .left {
                width: 100%;
                margin-bottom: 20px;

                .list {
                    font-size: 14px;
                    min-height: 40px;
                    padding: 8px;
                }
            }

            .right {
                margin-left: 0;

                .right-con {
                    padding: 15px;

                    .right-con-title {
                        font-size: 18px;
                    }

                    .right-con-text {
                        font-size: 14px;
                        min-height: 300px;
                    }
                }
            }
        }

        .no-data {
            margin: 100px 0;

            img {
                width: 120px;
            }

            p {
                font-size: 14px;
            }
        }
    }
}

/* 响应式适配：小屏幕设备 */
@media (max-width: 480px) {
    .tours {
        padding-bottom: 60px;

        .top {
            height: 160px;

            .title {
                font-size: 24px;
                padding: 0 15px;
            }
        }

        .nav {
            padding: 10px 0;

            .nav-con {
                .list {
                    font-size: 12px;
                    height: 30px;
                    margin: 3px 3px;
                    padding: 0 6px;
                }
            }
        }

        .content {
            margin: 15px auto;
            width: calc(100% - 15px);

            .left {
                .list {
                    font-size: 13px;
                    min-height: 35px;
                    padding: 6px;
                }
            }

            .right {
                .right-con {
                    padding: 12px;

                    .right-con-title {
                        font-size: 16px;
                    }

                    .right-con-text {
                        font-size: 13px;
                        min-height: 250px;
                    }
                }
            }
        }

        .no-data {
            margin: 80px 0;

            img {
                width: 100px;
            }

            p {
                font-size: 13px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/en/immigration.vue